export type Interval = keyof typeof IntervalNamesMap;

export const IntervalNamesMap = {
  MinorSecond: "Minor 2nd",
  MajorSecond: "Major 2nd",
  MinorThird: "Minor 3rd",
  MajorThird: "Major 3rd",
  PerfectFourth: "Perfect 4th",
  FlatFifth: "Flat 5th",
  PerfectFifth: "Perfect 5th",
  MinorSixth: "Minor 6th",
  MajorSixth: "Major 6th",
  MinorSeventh: "Minor 7th",
  MajorSeventh: "Major 7th",
  // Octave,
  // Minor9th
  // Major9th
  // ...
};

export const Intervals = Object.keys(IntervalNamesMap);

export const IntervalToHalfStepsMap = {
  MinorSecond: 1,
  MajorSecond: 2,
  MinorThird: 3,
  MajorThird: 4,
  PerfectFourth: 5,
  FlatFifth: 6,
  PerfectFifth: 7,
  MinorSixth: 8,
  MajorSixth: 9,
  MinorSeventh: 10,
  MajorSeventh: 11,
  // Octave,
  // Minor9th
  // Major9th
  // ...
};
